import { render, staticRenderFns } from "./taxes.vue?vue&type=template&id=b7b64aa2"
import script from "./taxes.vue?vue&type=script&lang=js"
export * from "./taxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports